import styled from 'styled-components';

const Wrapper = styled.div`
	padding-bottom: 20px;
	.content-info {
		margin: 20px 0;
		.description,
		.warning {
			margin: 0;
			line-height: 1.5;
		}
	}
	.contact-type {
		color: #FFFFFF;
		padding-top: 12px;
	}
	a {
		color: #3A4FFF;
	}
`;

export default Wrapper;
